export enum UserRoleEnum {
  SiteManager = 1,
  EventCreator = 2,
  Estimator = 3,
  Viewer = 4,
}
